import { render } from "preact";
import { App } from "./App";
import "./styles/observatory.css";
import { getLocale, setLocale } from "./i18n";

const LOCALE_KEY = "boostscience_observatory_locale";
let initialLocale = "en";
try {
  const stored = localStorage.getItem(LOCALE_KEY);
  if (stored === "uk" || stored === "en") initialLocale = stored;
  else if ((document.documentElement.lang || "").toLowerCase().startsWith("uk")) initialLocale = "uk";
} catch {}
setLocale(initialLocale);
document.documentElement.lang = getLocale() === "uk" ? "uk" : "en";

function syncHeaderOffset() {
  const root = (document.querySelector(".bs-observatory") ?? document.body) as HTMLElement;
  const header =
    document.querySelector<HTMLElement>(".nav-menu.header-one") ??
    document.querySelector<HTMLElement>(".nextsaas-header .nav-menu");
  const bottom = header ? Math.ceil(header.getBoundingClientRect().bottom) : 96;
  const offset = Math.max(bottom + 20, 128);
  root.style.setProperty("--obs-header-offset", `${offset}px`);
  root.style.setProperty("--obs-sticky-top", `${bottom + 8}px`);
}

syncHeaderOffset();
window.addEventListener("resize", syncHeaderOffset);

const leftover = document.querySelector(".bs-observatory .page-header");
leftover?.parentElement?.removeChild(leftover);

const root = document.getElementById("boostscience-observatory");
if (root) {
  root.replaceChildren();
  document.documentElement.classList.add("obs-app-ready");
  render(<App />, root);
}

requestAnimationFrame(syncHeaderOffset);
